module.exports = __webpack_public_path__ + "static/media/main_background.db70a0be.mp3";